//Combine class names for tailwind function
export const classNames = (...classes: string[]): string => {
    return classes.filter(Boolean).join(' ')
}

export const TitleSuffix = ' | Watskebeurt.nl - P2000 - 112 Meldingen'